import React from "react";
import { Box, Typography, LinearProgress } from "@mui/material";

function PercentageProgress(props) {
	const percentage = props.total ? Math.min(Math.round((props.value / props.total) * 100), 100) : 0;

	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				gap: 1,
				width: "100%",
			}}
		>
			<Typography
				sx={{
					minWidth: 35,
					fontSize: 12,
					fontWeight: 500,
					color: percentage === 100 ? "#388e3c" : percentage > 0 ? "#f57c00" : "#666",
				}}
			>
				{percentage}%
			</Typography>

			<LinearProgress
				variant="determinate"
				value={percentage}
				sx={{
					flex: 1,
					height: 7,
					borderRadius: 4,
					backgroundColor: "#e1e4e8",

					"& .MuiLinearProgress-bar": {
						borderRadius: 4,
						backgroundColor: percentage === 100 ? "#4caf50" : percentage > 0 ? "#ff9800" : "#d5d8dc",
					},
				}}
			/>
		</Box>
	);
}

/*
	Obbligatori:
		valueField
		totalField
	Facoltativi:
		headerName
		width
*/
export default function SaitProgressBarColumn(props) {
	return {
		headerName: props.headerName,
		width: props.width,
		minWidth: props.minWidth,
		flex: props.flex,
		align: props.align || "center",
		hidden: props.hidden || false,
		display: "flex",
		objmod: props.objmod,
		startPinned: props.startPinned,
		endPinned: props.endPinned,
		renderCell: (params) => <PercentageProgress value={params.row[props.valueField]} total={params.row[props.totalField]} />,
	};
}
